"use strict";

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var prosemirror_view_1 = require("prosemirror-view");

var Extension_1 = __importDefault(require("../lib/Extension"));

var Placeholder = /*#__PURE__*/function (_Extension_1$default) {
  _inherits(Placeholder, _Extension_1$default);

  var _super = _createSuper(Placeholder);

  function Placeholder() {
    _classCallCheck(this, Placeholder);

    return _super.apply(this, arguments);
  }

  _createClass(Placeholder, [{
    key: "name",
    get: function get() {
      return "empty-placeholder";
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        emptyNodeClass: "placeholder",
        placeholder: ""
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          decorations: function decorations(state) {
            var doc = state.doc;
            var decorations = [];
            var completelyEmpty = doc.textContent === "" && doc.childCount <= 1 && doc.content.size <= 2;
            doc.descendants(function (node, pos) {
              if (!completelyEmpty) {
                return;
              }

              if (pos !== 0 || node.type.name !== "paragraph") {
                return;
              }

              var decoration = prosemirror_view_1.Decoration.node(pos, pos + node.nodeSize, {
                class: _this.options.emptyNodeClass,
                "data-empty-text": _this.options.placeholder
              });
              decorations.push(decoration);
            });
            return prosemirror_view_1.DecorationSet.create(doc, decorations);
          }
        }
      })];
    }
  }]);

  return Placeholder;
}(Extension_1.default);

exports.default = Placeholder;